var _path, _rect, _line, _line2, _path2, _line3, _line4, _line5, _path3, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.71411 1C5.71411 0.447715 6.16183 0 6.71411 0H14.9998C15.5521 0 15.9998 0.447715 15.9998 1V18.2857H5.71411V1Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.14264,
    y: 12.5713,
    width: 4.57143,
    height: 5.71429,
    fill: "#2D4E85"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.00037,
    y1: 5.21436,
    x2: 13.7147,
    y2: 5.21436,
    stroke: "#2D4E85"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.7858,
    y1: 2.28564,
    x2: 10.7858,
    y2: 7.99993,
    stroke: "#2D4E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 3.42871H20.7141C21.2664 3.42871 21.7141 3.87643 21.7141 4.42871V17.2859C21.7141 17.8381 21.2664 18.2859 20.7141 18.2859H17.1426V3.42871Z",
    fill: "currentColor"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2857,
    y1: 6.35742,
    x2: 21.7143,
    y2: 6.35742,
    stroke: "#2D4E85"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2857,
    y1: 9.78564,
    x2: 21.7143,
    y2: 9.78564,
    stroke: "#2D4E85"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 18.2857,
    y1: 13.2144,
    x2: 21.7143,
    y2: 13.2144,
    stroke: "#2D4E85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000183105 4.42871C0.000183105 3.87643 0.447898 3.42871 1.00018 3.42871H4.57161V18.2859H1.00018C0.447899 18.2859 0.000183105 17.8381 0.000183105 17.2859V4.42871Z",
    fill: "currentColor"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0.000366211,
    y1: 6.35742,
    x2: 3.42894,
    y2: 6.35742,
    stroke: "#2D4E85"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0.000366211,
    y1: 9.78564,
    x2: 3.42894,
    y2: 9.78564,
    stroke: "#2D4E85"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 0.000366211,
    y1: 13.2144,
    x2: 3.42894,
    y2: 13.2144,
    stroke: "#2D4E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/Clinic.43bc8c6005d67e4ac734176984488c92.svg";
export { ForwardRef as ReactComponent };